import * as React from 'react';
import FAB from '../../../components/core/FAB';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faFilter,
  faFire,
  faFont,
  faLanguage,
  faPalette,
  faVolumeHigh,
} from '@fortawesome/free-solid-svg-icons';
import { ColorPalette } from '../../../constant';
import { useLiveQuery } from 'dexie-react-hooks';
import { useContext } from 'react';
import { DexieContext, USER } from '../../../components/core/PageWrapper';

const FlashcardsConfig: React.FC = () => {
  const db = useContext(DexieContext);
  const config = useLiveQuery(
    async () => await db.table('config').where('id').equals(USER).first()
  );

  function handleConfig(field: string) {
    db.table('config').update(USER, {
      [field]: Number(!config[field]),
    });
  }

  const actions = [
    {
      label: 'Type',
      icon: <FontAwesomeIcon icon={faFont} color="black" />,
      onClick: () => handleConfig('flashCardsHideType'),
    },
    {
      label: 'Pinyin',
      icon: <FontAwesomeIcon icon={faLanguage} color="black" />,
      onClick: () => handleConfig('flashCardsHidePinyin'),
    },
    {
      label: 'Audio',
      icon: <FontAwesomeIcon icon={faVolumeHigh} color="black" />,
      onClick: () => handleConfig('flashCardsHideAudio'),
    },
    {
      label: 'Only Difficult',
      icon: <FontAwesomeIcon icon={faFire} color="black" />,
      onClick: () => handleConfig('flashCardsHideEasy'),
    },
    {
      label: 'Tone Colors',
      icon: <FontAwesomeIcon icon={faPalette} color="black" />,
      onClick: () => handleConfig('flashCardsHideToneColor'),
    },
  ];

  return (
    <FAB
      actions={actions}
      left
      top
      textColor={ColorPalette.WHITE}
      backgroundColor={ColorPalette.DARKER_BLUE}
      icon={faFilter}
    />
  );
};

export default FlashcardsConfig;
